import React from "react";
import UserInfoStores from "../../stores/userInfoStores";

//   Structure-------    0:['bordercolor',"Background color","image url"]
const toasterTypeDetails = {
    0: ["#62d2a2", "#e5f8f6", "/assets/images/toast-success.svg"], //success
    1: ["#f45d5d", "#faefe5", "/assets/images/toast-error.svg"],
    2: ["#eb9c00", "#fdf5e5", "/assets/images/toastPending.svg"] // Pending
};

// PASS PARAMETER AS (MESSAGE_STRING,TOASTTYPE) *******   TOAST TYPE====> SUCCESS(0),DANGER(1)

export default class Toaster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            closeToast: true,
            msgForToast: { message: "", toastType: 0 },
            setTimeOut: null,
            clearContentAfterAnimation: null,
            className: this.retunToasterClassName(props)
        };
        this._storeChanged = this._storeChanged.bind(this);
        this._setToastState = this._setToastState.bind(this);
        this._clearToastUsingTimer = this._clearToastUsingTimer.bind(this);
        this._closeToastManually = this._closeToastManually.bind(this);
    }
    componentDidMount() {
        UserInfoStores.on("change", this._storeChanged);
    }

    componentWillUnmount() {
        UserInfoStores.removeListener("change", this._storeChanged);
    }

    retunToasterClassName(props) {
        let getClassName = `customToast ${props.className}`;
        return getClassName;
    }

    _setToastState(
        closeToast,
        msgForToast,
        setTimeOut,
        className,
        clearContentAfterAnimation = null
    ) {
        this.setState({
            clearContentAfterAnimation,
            closeToast,
            msgForToast,
            setTimeOut,
            className
        });
    }
    _storeChanged(type) {
        // console.log("Inside toast");
        if ("toast" == type) {
            clearTimeout(this.state.setTimeOut);
            clearTimeout(this.state.clearContentAfterAnimation);
            let msgForToast = UserInfoStores._getMsgForToast() || {};
            let setTimeOut = this._clearToastUsingTimer(msgForToast.message);
            this._setToastState(
                false,
                msgForToast,
                setTimeOut,
                `${this.retunToasterClassName(this.props)} showCustomToast`
            );
        }
    }
    _closeToastManually() {
        clearTimeout(this.state.setTimeOut);
        this._setToastState(
            true,
            this.state.msgForToast,
            null,
            `${this.retunToasterClassName(this.props)} closeCustomToast`,
            this._clearToastUsingTimer("", 3000)
        );
    }
    _clearToastUsingTimer(msg, timerValue = 5000) {
        return setTimeout(() => {
            //this._setToastState(true,{message:'',toastType:0},null,'toast close');
            this._setToastState(
                true,
                { message: msg, toastType: this.state.msgForToast.toastType },
                null,
                `${this.retunToasterClassName(this.props)} closeCustomToast`,
                timerValue != 3000 ? this._clearToastUsingTimer("", 3000) : null
            );
        }, timerValue);
    }
    render() {
        return (
            <ToastData
                closeToastManually={this._closeToastManually}
                className={this.state.className}
                key={this.state.msgForToast.toastType}
                toastType={this.state.msgForToast.toastType}
                message={this.state.msgForToast.message}
            />
        );
    }
}
function ToastData(props) {
    return (
        <div
            className={props.className}
            style={{
                border: `1px solid ${toasterTypeDetails[props.toastType][0]}`,
                background: toasterTypeDetails[props.toastType][1]
            }}
        >
            <div>
                <img src={toasterTypeDetails[props.toastType][2]} />
            </div>
            <div className="customToastContent">{props.message}</div>
            <div style={{ marginLeft: "auto", cursor: "pointer" }}>
                <img onClick={props.closeToastManually} src="/assets/images/close-icon.svg" />
            </div>
        </div>
    );
}
